<template>
  <div>
    <b-row>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Первый год обучения (PhD):</strong>
          </p>
          <ol>
            <li>"Индивидуальный план (до 5 МБ)" (pdf).</li>
            <li>"Теоретическая и методологическая программа (до 5 МБ)" (pdf).</li>
            <li>"Научная статья (до 5 МБ)" (pdf). (Как минимум одна)</li>
            <li>"Тезис (до 5 МБ)" (pdf). (Как минимум один)</li>
            <li>"Аналитическая информация по теме диссертации (до 5 МБ)" (pdf).</li>
            <li>"Отчет о семинаре (до 5 МБ)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Второй год обучения (PhD):</strong>
          </p>
          <ol>
            <li>"Научная статья (до 5 МБ)" (pdf). (Как минимум одна)</li>
            <li>"Тезис (до 5 МБ)" (pdf). (Как минимум один)</li>
            <li>"Зарубежная научная статья (до 5 МБ)" (pdf). (Как минимум одна)</li>
            <li>"Отчет о семинаре (до 5 МБ)" (pdf).</li>
            <li>"Отчет (до 5 МБ)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Третий год обучения (PhD):</strong>
          </p>
          <ol>
            <li>"Научная статья (до 5 МБ)" (pdf). (Как минимум одна)</li>
            <li>"Тезис (до 5 МБ)" (pdf). (Как минимум один)</li>
            <li>"Зарубежная научная статья (до 5 МБ)" (pdf). (Как минимум одна)</li>
            <li>"Диссертация (до 15 МБ)" (pdf).</li>
            <li>"Автореферат диссертации (до 7 МБ)" (pdf).</li>
            <li>"Отчет о семинаре (до 5 МБ)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Первый год обучения (DSc):</strong>
          </p>
          <ol>
            <li>"Индивидуальный план (до 5 МБ)" (pdf).</li>
            <li>"Научная статья (до 5 МБ)" (pdf). (Как минимум три)</li>
            <li>"Тезис (до 5 МБ)" (pdf). (Как минимум один)</li>
            <li>"Отчет о семинаре (до 5 МБ)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Второй год обучения (DSc):</strong>
          </p>
          <ol>
            <li>"Научная статья (до 5 МБ)" (pdf). (Как минимум три)</li>
            <li>"Зарубежная научная статья (до 5 МБ)" (pdf). (Как минимум одна)</li>
            <li>"Тезис (до 5 МБ)" (pdf). (Как минимум один)</li>
            <li>"Отчет о семинаре (до 5 МБ)" (pdf).</li>
            <li>"Отчет (до 5 МБ)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
      <b-col
        cols="4"
        md="4"
      >
        <b-card
          id="guide"
          style="font-family: TimesNewRoman,serif; font-size: 18px"
        >
          <p style="font-size: 20px;">
            <strong>Третий год обучения (DSc):</strong>
          </p>
          <ol>
            <li>"Научная статья (до 5 МБ)" (pdf). (Как минимум три)</li>
            <li>"Монография (до 15 МБ)" (pdf). (В социально-гуманитарных науках)</li>
            <li>"Диссертация (до 15 МБ)" (pdf).</li>
            <li>"Автореферат диссертации (до 7 МБ)" (pdf).</li>
            <li>"Отчет о семинаре (до 5 МБ)" (pdf).</li>
          </ol>
        </b-card>
      </b-col>
    </b-row>
    <b-card
      id="guide"
      style="font-family: TimesNewRoman,serif; font-size: 18px"
    >
      <p style="font-size: 20px;">
        <strong>Первый год обучения (Младший научный сотрудник):</strong>
      </p>
      <ol>
        <li>"Индивидуальный план (до 5 МБ)" (pdf).</li>
        <li>"Научная статья (до 5 МБ)" (pdf). (Как минимум одна)</li>
        <li>"Тезис (до 5 МБ)" (pdf). (Как минимум один)</li>
      </ol>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCol, BRow } from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCard,
    BCol,
  },
}
</script>

<style scoped>
</style>
